import script from "./service-subscribe.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-subscribe.vue?vue&type=script&lang=ts&setup=true"

import "./service-subscribe.vue?vue&type=style&index=0&id=761d06ea&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761d06ea"]])

export default __exports__